import { useFormContext } from "react-hook-form";

import { classed } from "@/components/classed.config";
import { IconButton } from "@/components/elements/Button";
import LoadingSpinner from "@/components/elements/LoadingSpinner";
import Tooltip from "@/components/elements/Tooltip";
import { useDataWarehouseContext } from "@/providers/DataWarehouseProvider";
import { ArrowPathIcon } from "@heroicons/react/20/solid";

import { FormValues } from "../../form";
import { EndpointBadge } from "./EndpointBadge";

export const MappingGrid = classed.div(
  "grid items-start gap-x-4 gap-y-1 sm:grid-cols-[1fr_20px_1fr]",
);

export function MappingGridHeader(props: {
  destinationIntegrationId: string;
  isLoadingSourceProperties: boolean;
  isLoadingDestinationProperties: boolean;
  onRefreshSourceProperties: () => void;
  onRefreshDestinationProperties: () => void;
}) {
  const dwh = useDataWarehouseContext();
  const formContext = useFormContext<FormValues>();

  const selectedSource = formContext.watch("source");
  const selectedObjectType = formContext.watch("objectTypeOption");

  if (!selectedSource || !selectedObjectType) {
    return null;
  }
  return (
    <MappingGrid>
      <div className="flex min-w-0 items-center">
        <EndpointBadge integrationId={dwh.integration.id}>
          {selectedSource.label}
        </EndpointBadge>
        <div className="ml-auto flex items-center">
          {props.isLoadingSourceProperties ? (
            <LoadingSpinner className="h-4 w-4" />
          ) : (
            <Tooltip content="Refresh source properties">
              <IconButton
                icon={<ArrowPathIcon />}
                variant="ghost"
                size="xs"
                onClick={() => {
                  props.onRefreshSourceProperties();
                }}
              />
            </Tooltip>
          )}
        </div>
      </div>
      <div></div>
      <div className="flex min-w-0 items-center">
        <EndpointBadge integrationId={props.destinationIntegrationId}>
          {selectedObjectType.objectName}
        </EndpointBadge>
        <div className="ml-auto flex items-center">
          {props.isLoadingDestinationProperties ? (
            <LoadingSpinner className="h-4 w-4" />
          ) : (
            <Tooltip content="Refresh destination properties">
              <IconButton
                icon={<ArrowPathIcon />}
                variant="ghost"
                size="xs"
                onClick={() => {
                  props.onRefreshDestinationProperties();
                }}
              />
            </Tooltip>
          )}
        </div>
      </div>
    </MappingGrid>
  );
}
